import { useCallback, useState } from 'react';

const useUIElementState = (
  defaultState = false,
) => {
  const [shouldShowElement, setShouldShowElement] = useState(defaultState);
  const showElement = useCallback(() => setShouldShowElement(true), []);
  const hideElement = useCallback(() => setShouldShowElement(false), []);

  return {
    showElement,
    hideElement,
    shouldShowElement,
  };
};

export default useUIElementState;
